import { Component, inject } from "@angular/core";
import { CardModalService } from "@app/shared/card-modal/card-modal.service";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-panel-icon-cellphone",
    imports: [TranslateModule, JumpstartComponentsModule],
    templateUrl: "./panel-icon-cellphone.component.html",
    host: { class: "wk-cm__header__icon wk-cm__header__icon-smartphone" },
})
export class PanelIconCellphoneComponent {
    protected readonly cardModalService = inject(CardModalService);
}
